import { Box, useRadio, UseRadioProps } from "@chakra-ui/react";
import styles from "./styles.module.scss";

interface CustomRadioButtonProps {
  label: string;
  index: number;
}

const CustomRadioButton = (props: UseRadioProps & CustomRadioButtonProps) => {
  const { getInputProps, getCheckboxProps } = useRadio(props);
  const input = getInputProps();
  const checkbox = getCheckboxProps();
  const { index, label, isChecked } = props;

  const getClassName = () => {
    if (index === 0) {
      if (!isChecked) {
        // remove right border
        return styles.removeRightBorder;
      } else {
        return styles.roundRightBorder;
      }
    } else {
      // case when button has index > 0
      if (!isChecked) {
        // removeLeftBorder
        return styles.removeLeftBorder;
      } else {
        // roundLeftborder
        return styles.roundLeftBorder;
      }
    }
  };

  return (
    <Box
      borderRadius="8px"
      cursor="pointer"
      as="label"
      color="textPrimary"
      bg="transparent"
      borderWidth="1px"
      borderColor="seperator"
      p="0.5rem 1rem"
      textAlign="center"
      h="36px"
      ml={index > 0 ? "-4px" : 0}
      _light={{
        color: "textPrimary",
      }}
      _checked={{
        borderColor: "textPrimary",
        _light: {
          borderColor: "primary",
          color: "primary",
        },
        boxShadow: "none",
      }}
      fontWeight="600"
      fontSize="14px"
      className={getClassName()}
      {...checkbox}
    >
      <input {...input} />
      {label}
    </Box>
  );
};

export default CustomRadioButton;
